import { RESCHEDULE_TOKEN_PARAM } from '@features/blockit-link/constants';
import { RescheduleTokenStore } from '@features/blockit-link/rescheduleTokenStore';

interface LinkPageLoaderData {
  rescheduleToken?: string;
}

/**
 * The token normally reached the tab at bootstrap and is gone from the URL by now; the URL is only
 * consulted for the case where storage refused it and the bootstrap left it in place.
 */
export const linkPageLoader = ({
  meetingId,
  searchStr,
}: {
  meetingId: string | undefined;
  searchStr: string;
}): LinkPageLoaderData => {
  if (!meetingId) {
    return {};
  }
  return {
    rescheduleToken: new URLSearchParams(searchStr).get(RESCHEDULE_TOKEN_PARAM) ?? RescheduleTokenStore.read(meetingId),
  };
};
